export type PerformanceUnsavedActions =
  (typeof PERFORMANCE_UNSAVED_ACTIONS)[keyof typeof PERFORMANCE_UNSAVED_ACTIONS]
export const PERFORMANCE_UNSAVED_ACTIONS = {
  DISCARD: 'discard',
  SAVE: 'save',
  STAY: 'stay',
}
